import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CloseIcon from '@mui/icons-material/Close'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import TilesPage from '../TilesPage'
import { getPreviousWellnessTileLabel } from '../../helpers/wellnessTileNavigation'
import { useWellnessTileNavigation } from '../../context/useWellnessTileNavigation'
import {
  StyledWellnessTileDrawer,
  WellnessTileDrawerActions,
  WellnessTileDrawerBackButton,
  WellnessTileDrawerBody,
  WellnessTileDrawerHeader,
  WellnessTileDrawerIconButton,
  WellnessTileDrawerShell,
  WellnessTileDrawerTitle,
  WellnessTileDrawerTitleBlock,
} from './WellnessTileDrawerStyles'

export default function WellnessTileDrawer() {
  const {
    isTileDrawerOpen,
    drawerState,
    backFromTileDrawer,
    closeTileDrawer,
    openTileAsPage,
  } = useWellnessTileNavigation()

  if (!drawerState) return null

  const previousLabel = getPreviousWellnessTileLabel(drawerState)
  const drawerTitle = drawerState?.label || 'Wellness'

  return (
    <StyledWellnessTileDrawer anchor="right" open={isTileDrawerOpen} onClose={closeTileDrawer}>
      <WellnessTileDrawerShell>
        <WellnessTileDrawerHeader>
          <WellnessTileDrawerTitleBlock>
            <WellnessTileDrawerBackButton type="button" onClick={backFromTileDrawer}>
              <ArrowBackIcon sx={{ fontSize: 18 }} />
              <span>Back to {previousLabel}</span>
            </WellnessTileDrawerBackButton>
            <WellnessTileDrawerTitle>{drawerTitle}</WellnessTileDrawerTitle>
          </WellnessTileDrawerTitleBlock>

          <WellnessTileDrawerActions>
            <WellnessTileDrawerIconButton
              type="button"
              aria-label="Open tile as page"
              title="Open as page"
              onClick={openTileAsPage}
            >
              <OpenInFullIcon sx={{ fontSize: 19 }} />
            </WellnessTileDrawerIconButton>
            <WellnessTileDrawerIconButton
              type="button"
              aria-label="Close tile drawer"
              title="Close"
              onClick={closeTileDrawer}
            >
              <CloseIcon sx={{ fontSize: 22 }} />
            </WellnessTileDrawerIconButton>
          </WellnessTileDrawerActions>
        </WellnessTileDrawerHeader>

        <WellnessTileDrawerBody>
          <TilesPage
            presentation="drawer"
            tileIdOverride={drawerState?.tileId}
            policyIdOverride={drawerState?.policyId}
          />
        </WellnessTileDrawerBody>
      </WellnessTileDrawerShell>
    </StyledWellnessTileDrawer>
  )
}
